export default __webpack_public_path__ + "static/media/cloud.5577f61d.svg";